module.exports = __webpack_public_path__ + "img/Target_case_study_1.457c2de1.png";